export default "__VITE_ASSET__DGVMBAvx__"